export const
    COMMENTS_RESET = 'comments_reset',
    COMMENTS_PENDING = 'comments_pending',
    COMMENT_DELETED = 'comment_deleted',
    COMMENT_POSTING = 'comment_posting',
    COMMENT_DELETING = 'comment_deleting',
    COMMENT_FAILED = 'comment_failed',
    COMMENTS_FAILED = 'comments_failed',
    COMMENTS_DOWNLOADED = 'comments_downloaded';



// WEBPACK FOOTER //
// src/store/comments/types.js